import React, { useContext } from "react";
import nodeContext from "../Context/Notes/NotesContext";
import { Box, Skeleton } from "@mui/material";

const Loading = () => {
  const context = useContext(nodeContext);
  const { loading } = context;
  return (
    <>
      <Box display="flex" flexWrap="wrap" justifyContent="center">
        <Skeleton
          variant="rounded"
          width={210}
          height={150}
          sx={{ bgcolor: "rgba(255,255,255,0.7)", margin: "30px" }}
        />
        <Skeleton
          variant="rounded"
          width={210}
          height={150}
          sx={{ bgcolor: "rgba(255,255,255,0.7)", margin: "30px" }}
        />
        <Skeleton
          variant="rounded"
          width={210}
          height={150}
          sx={{ bgcolor: "rgba(255,255,255,0.7)", margin: "30px" }}
        />
        <Skeleton
          variant="rounded"
          width={210}
          height={150}
          sx={{ bgcolor: "rgba(255,255,255,0.7)", margin: "30px" }}
        />
      </Box>
    </>
  );
};

export default Loading;
